import { PropsWithChildren } from 'react';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { ButtonWithDropdown, DropdownItem } from '@ardoq/dropdown-menu';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import { ButtonType } from '@ardoq/button';
import { DecoratorPlaceholder } from '@ardoq/decorators';

type CellPlaceholderProps = PropsWithChildren<{
  placeholder: string;
}>;

export const CellPlaceholder = ({
  placeholder = 'Unset',
  children,
}: CellPlaceholderProps) => (
  <>{children || <DecoratorPlaceholder>{placeholder}</DecoratorPlaceholder>}</>
);

type CellWithDropdownProps = {
  options: Partial<DropdownItem>[];
  dropdownSize?: DropdownSize;
  alignMenuTo?: 'left' | 'right';
  dataTestId?: string;
  trackOnClick?: () => void;
  ariaLabel?: string;
};

export const CellWithDropdown = ({
  options,
  dropdownSize = DropdownSize.S,
  alignMenuTo = 'right',
  dataTestId,
  trackOnClick,
  ariaLabel = 'More options',
}: CellWithDropdownProps) => (
  <ButtonWithDropdown
    aria-label={ariaLabel}
    buttonType={ButtonType.GHOST}
    dropdownSize={dropdownSize}
    alignMenuTo={alignMenuTo}
    options={options}
    hideChevron
    dataTestId={dataTestId}
    onClick={trackOnClick}
  >
    <Icon iconName={IconName.MORE_VERT} iconSize={IconSize.SMALL} />
  </ButtonWithDropdown>
);
